<template>
    <tab-section id="project-address-container" title="Location">
        <template v-slot:information>
            If you don't know the exact location, get as close as you can even if it's just a city and state.
        </template>

        <div v-if="editable || (project_physical_address && project_physical_address.line1)" :class="{'uk-text-required': !project_physical_address.city}" class="uk-flex uk-flex-middle">
            <open-icon
                v-if="!project_physical_address.city"
                glyph="exclamation-triangle"
                class="uk-margin-right"
            />
            <auto-save-address-form
                v-model="project_physical_address"
                :editable="editable"
                entity="address"
                class="uk-width-1-1"
            />
        </div>
        <div v-if="project_physical_address && parseFloat(project_physical_address.latitude) && parseFloat(project_physical_address.longitude)" class="lam-map-container">
            <google-map class="lam-map uk-margin-top" :locations="[{number: record.number, name: record.name, location: record.city_state, latitude: project_physical_address.latitude, longitude: project_physical_address.longitude}]" style="height: 155px;"></google-map>
        </div>
    </tab-section>
</template>

<script type="text/javascript">
import is_project_relation_tab_section from "../mixins/IsProjectRelationTabSection"
import has_addresses from "../../../mixins/HasAddresses"

import AutoSaveAddressForm from "../../../ui/AutoSaveAddressForm"
import GoogleMap from "../../../ui/GoogleMap"
import OpenIcon from "../../../ui/OpenIcon"

export default {
    mixins: [is_project_relation_tab_section, has_addresses],
    components: {
        AutoSaveAddressForm,
        GoogleMap,
        OpenIcon
    },
    computed: {
        project_physical_address () {
            return this.physical_address("App\\Project", this.record.id)
        }
    },
    data () {
        return {
            entity: "address"
        }
    }
}
</script>
